import { addListener } from "@grindex-common/helpers/domManipulation";

function init() {
	const $links = document.querySelector("a:not([#continue-link])");

	addListener($links, "click", setupEvents);

	function setupEvents(evt) {
		var hostname = this.hostname;
		var safeDomains = window.config.safeDomains;
		var target;
		var safe;

		if (hostname === window.location.hostname || !safeDomains) {
			return;
		}

		safe = safeDomains.some((domain) => {
			return domain.indexOf(hostname.replace("www.", "")) !== -1;
		});

		if (safe) {
			return;
		}

		evt.preventDefault();

		target = $(this).attr("target");
		if (!target) {
			target = "_self";
		}

		$("#safe-domain-modal #continue-link").attr("target", target);
		$("#safe-domain-modal #continue-link").attr("href", $(this).attr("href"));
		$("#safe-domain-modal").modal();
	}
}

export default {
	view: "safeDomainLink",
	init,
};
